(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };


  ready(() => {

    /* =====================================================
       ROTATING SEARCH PLACEHOLDERS
       ===================================================== */

    const headerSection =
      document.querySelector('.header-wrapper[data-syn-search-one]');

    if (!headerSection) return;


    const phrases = [
      headerSection.dataset.synSearchOne,
      headerSection.dataset.synSearchTwo,
      headerSection.dataset.synSearchThree,
      headerSection.dataset.synSearchFour
    ].filter(Boolean);


    const interval =
      Math.max(
        2000,
        Number(
          headerSection.dataset.synSearchSpeed || 3200
        )
      );


    const searchInputs =
      [
        ...document.querySelectorAll(
          'input[type="search"][name="q"]'
        )
      ];


    if (phrases.length > 1 && searchInputs.length) {

      let index = 0;


      window.setInterval(() => {

        index =
          (index + 1) %
          phrases.length;


        searchInputs.forEach((input) => {

          if (
            document.activeElement === input ||
            input.value
          ) {
            return;
          }


          input.style.opacity = '.35';


          window.setTimeout(() => {

            input.placeholder =
              phrases[index];

            input.style.opacity = '1';

          }, 130);

        });

      }, interval);

    }



    /* =====================================================
       DESKTOP CUSTOM CART → NATIVE SHOPIFY CART
       ===================================================== */

    const utilityCart =
      document.querySelector(
        '[data-synmac-utility-cart]'
      );


    utilityCart?.addEventListener(
      'click',
      (event) => {

        const nativeCart =
          document.getElementById(
            'cart-icon-bubble'
          );


        if (!nativeCart) return;


        event.preventDefault();


        nativeCart.click();

      }
    );



    /* =====================================================
   SYNMAC CART BADGE — FOLLOW SHOPIFY CART BUBBLE
   One cart state, no extra /cart.js request
   ===================================================== */

const syncUtilityCounter = () => {
  const nativeCount =
    document.querySelector(
      '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]'
    );

  const count =
    nativeCount?.textContent?.trim() || '0';

  document
    .querySelectorAll('[data-synmac-cart-count]')
    .forEach((badge) => {
      badge.textContent = count;
    });
};

const nativeCartBubble =
  document.getElementById('cart-icon-bubble');

if (nativeCartBubble) {
  syncUtilityCounter();

  const cartCounterObserver =
    new MutationObserver(() => {
      syncUtilityCounter();
    });

  cartCounterObserver.observe(
    nativeCartBubble,
    {
      childList: true,
      subtree: true,
      characterData: true
    }
  );
}

  });

})();
/* =========================================================
   SYNMAC MOBILE DRAWERS V2
   Safe isolated mobile drawer controller
   ========================================================= */

(() => {
  'use strict';

  const NS = 'synx';
  const MOBILE = window.matchMedia('(max-width: 989px)');

  const $ = (selector, context = document) =>
    context.querySelector(selector);

  const $$ = (selector, context = document) =>
    [...context.querySelectorAll(selector)];

  const escapeHTML = (value = '') =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');


  /* ======================================================
     ROUTES
     ====================================================== */

  const root =
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  const searchURL = `${root}search`;

  const headerConfig =
    document.querySelector(
      '.header-wrapper[data-syn-search-one]'
    );

  const accountURL =
    headerConfig?.dataset.synxAccountUrl ||
    `${root}account`;

  const loginURL =
    headerConfig?.dataset.synxLoginUrl ||
    accountURL;

  const registerURL =
    headerConfig?.dataset.synxRegisterUrl ||
    `${root}account/register`;

  const logoutURL =
    headerConfig?.dataset.synxLogoutUrl ||
    `${root}account/logout`;

  const customerLoggedIn =
    headerConfig?.dataset.synxCustomer === 'true';

  const customerName =
    headerConfig?.dataset.synxCustomerName || '';

  let activeTrigger = null;


  /* ======================================================
     CURRENT SEARCH SETTINGS
     Reuses your existing Header Theme Editor terms
     ====================================================== */

  const existingSearch =
    document.querySelector(
      '.syn-header-search[data-syn-search]'
    );

  const getTerms = () => {
    const fallback = [
      headerConfig?.dataset.synSearchOne,
      headerConfig?.dataset.synSearchTwo,
      headerConfig?.dataset.synSearchThree,
      headerConfig?.dataset.synSearchFour
    ].filter(Boolean);

    if (!existingSearch) {
      return fallback;
    }

    const values = [];

    for (let i = 1; i <= 6; i += 1) {
      const value =
        existingSearch.getAttribute(
          `data-term-${i}`
        );

      if (value && value.trim()) {
        values.push(value.trim());
      }
    }

    return values.length
      ? values
      : fallback;
  };


  const getPlaceholder = () => {
    const desktopInput =
      existingSearch &&
      existingSearch.querySelector(
        'input[type="search"]'
      );

    return (
      desktopInput?.getAttribute('placeholder') ||
      headerConfig?.dataset.synSearchOne ||
      'Search products...'
    );
  };


  /* ======================================================
     ICONS
     ====================================================== */

  const searchIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="10.8" cy="10.8" r="6.4"></circle>
      <path d="M15.7 15.7 20 20"></path>
    </svg>
  `;

  const closeIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 5 19 19"></path>
      <path d="M19 5 5 19"></path>
    </svg>
  `;


  /* ======================================================
     BUILD
     ====================================================== */

  const buildUI = () => {

    if (
      document.querySelector(
        '.synx-mobile-overlay'
      )
    ) {
      return;
    }


    /* ---------- overlay ---------- */

    const overlay =
      document.createElement('div');

    overlay.className =
      'synx-mobile-overlay';

    overlay.setAttribute(
      'aria-hidden',
      'true'
    );


    /* ---------- search drawer ---------- */

    const searchDrawer =
      document.createElement('aside');

    searchDrawer.className =
      'synx-mobile-drawer synx-search-drawer';

    searchDrawer.id = 'SynxSearchDrawer';

    searchDrawer.setAttribute(
      'aria-hidden',
      'true'
    );

    searchDrawer.setAttribute('role', 'dialog');
    searchDrawer.setAttribute('aria-modal', 'true');
    searchDrawer.setAttribute('aria-label', 'Search');

    searchDrawer.innerHTML = `
      <div class="synx-drawer__header">

        <h2 class="synx-drawer__title">
          Search
        </h2>

        <button
          class="synx-drawer__close"
          type="button"
          aria-label="Close search"
          data-synx-close
        >
          ${closeIcon}
        </button>

      </div>

      <div class="synx-search-body">

        <form
          class="synx-mobile-search-form"
          action="${searchURL}"
          method="get"
          role="search"
        >

          <input
            class="synx-mobile-search-input"
            type="search"
            name="q"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            placeholder="${escapeHTML(
              getPlaceholder()
            )}"
            aria-label="Search products"
            data-synx-search-input
          >

          <input
            type="hidden"
            name="type"
            value="product"
          >

          <button
            class="synx-mobile-search-submit"
            type="submit"
            aria-label="Search"
          >
            ${searchIcon}
          </button>

        </form>

        <section class="synx-search-section">

          <h3 class="synx-search-section-title">
            Trending Now
          </h3>

          <div
            class="synx-trending-list"
            data-synx-trending
          ></div>

        </section>

        <div
          class="synx-search-results"
          data-synx-results
          role="status"
          aria-live="polite"
          aria-atomic="false"
          hidden
        ></div>

      </div>
    `;


    /* ---------- account drawer ---------- */

    const accountDrawer =
      document.createElement('aside');

    accountDrawer.className =
      'synx-mobile-drawer synx-account-drawer';

    accountDrawer.id = 'SynxAccountDrawer';

    accountDrawer.setAttribute(
      'aria-hidden',
      'true'
    );

    accountDrawer.setAttribute('role', 'dialog');
    accountDrawer.setAttribute('aria-modal', 'true');
    accountDrawer.setAttribute('aria-label', 'Customer account');

    accountDrawer.innerHTML = customerLoggedIn
      ? `
        <div class="synx-drawer__header">
          <h2 class="synx-drawer__title">Account</h2>
          <button class="synx-drawer__close" type="button" aria-label="Close account" data-synx-close>
            ${closeIcon}
          </button>
        </div>
        <div class="synx-account-body">
          <h3 class="synx-account-heading">Welcome${customerName ? `, ${escapeHTML(customerName)}` : ''}</h3>
          <p class="synx-account-copy">View your account and manage your customer information.</p>
          <a class="synx-account-primary" href="${accountURL}">OPEN MY ACCOUNT</a>
          <div class="synx-account-divider" aria-hidden="true"></div>
          <a class="synx-account-secondary" href="${logoutURL}">SIGN OUT</a>
        </div>
      `
      : `
        <div class="synx-drawer__header">
          <h2 class="synx-drawer__title">Login</h2>
          <button class="synx-drawer__close" type="button" aria-label="Close account" data-synx-close>
            ${closeIcon}
          </button>
        </div>
        <div class="synx-account-body">
          <h3 class="synx-account-heading">Sign in to your account</h3>
          <p class="synx-account-copy">Access your orders and manage your customer account securely.</p>
          <a class="synx-account-primary" href="${loginURL}">LOG IN</a>
          <div class="synx-account-divider" aria-hidden="true"></div>
          <a class="synx-account-secondary" href="${registerURL}">CREATE ACCOUNT</a>
        </div>
      `;


    document.body.append(
      overlay,
      searchDrawer,
      accountDrawer
    );


    renderTrending();
    bindUI();
  };


  /* ======================================================
     TRENDING
     ====================================================== */

  const renderTrending = () => {

    const wrap =
      document.querySelector(
        '[data-synx-trending]'
      );

    if (!wrap) return;

    wrap.innerHTML =
      getTerms()
        .map(term => `
          <button
            class="synx-trending-pill"
            type="button"
            data-synx-term="${escapeHTML(term)}"
          >
            ${searchIcon}
            <span>${escapeHTML(term)}</span>
          </button>
        `)
        .join('');
  };


  /* ======================================================
     DRAWER STATE
     ====================================================== */

  const closeAll = (returnFocus = true) => {

    $$('.synx-mobile-drawer')
      .forEach(drawer => {
        drawer.classList.remove('is-open');

        drawer.setAttribute(
          'aria-hidden',
          'true'
        );
      });

    document.documentElement
      .classList.remove(
        'synx-drawer-open',
        'synx-mobile-lock'
      );

    document.body
      .classList.remove(
        'synx-mobile-lock'
      );

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
    }

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(returnFocus ? activeTrigger : null);
    } else if (returnFocus) {
      activeTrigger?.focus();
    }

    activeTrigger = null;
  };


  const openDrawer = (drawer, trigger = null) => {

    if (!MOBILE.matches) return;

    closeAll(false);
    activeTrigger = trigger;

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'true');
      activeTrigger.setAttribute('aria-controls', drawer.id);
    }

    drawer.classList.add('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement
      .classList.add(
        'synx-drawer-open',
        'synx-mobile-lock'
      );

    document.body
      .classList.add(
        'synx-mobile-lock'
      );

    if (
      drawer.classList.contains(
        'synx-search-drawer'
      )
    ) {
      window.setTimeout(() => {
        const input = drawer.querySelector('[data-synx-search-input]');

        if (input && typeof trapFocus === 'function') {
          trapFocus(drawer, input);
        } else {
          input?.focus();
        }
      }, 220);
    } else {
      window.setTimeout(() => {
        const firstFocusable = drawer.querySelector('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

        if (firstFocusable && typeof trapFocus === 'function') {
          trapFocus(drawer, firstFocusable);
        } else {
          firstFocusable?.focus();
        }
      }, 220);
    }
  };


  /* ======================================================
     SEARCH
     ====================================================== */

  let searchTimer = null;
  let controller = null;


  const renderProducts = products => {

    const wrap =
      document.querySelector(
        '[data-synx-results]'
      );

    if (!wrap) return;

    if (!products.length) {
      wrap.hidden = true;
      wrap.innerHTML = '';
      return;
    }

    wrap.innerHTML =
      products.map(product => {

        const title =
          escapeHTML(product.title || '');

        const url =
          escapeHTML(product.url || '#');

        const image =
          product.featured_image?.url
            ? escapeHTML(
                product.featured_image.url
              )
            : '';

        const currency =
  window.Shopify?.currency?.active ||
  document
    .querySelector('[data-syn-search]')
    ?.getAttribute('data-currency') ||
  'PKR';

const price =
  product.price !== undefined &&
  product.price !== null
    ? formatSearchPrice(
        product.price,
        currency
      )
    : '';

        return `
          <a
            class="synx-search-result"
            href="${url}"
          >

            ${
              image
                ? `
                  <img
                    src="${image}"
                    alt="${title}"
                    width="56"
                    height="56"
                    loading="lazy"
                  >
                `
                : `<span></span>`
            }

            <span
              class="synx-search-result__copy"
            >
              <strong>${title}</strong>

              ${
                price
                  ? `<small>${price}</small>`
                  : ''
              }
            </span>

            <span
              class="synx-search-result__arrow"
              aria-hidden="true"
            >
              ›
            </span>

          </a>
        `;
      }).join('');

    wrap.hidden = false;
  };


  const predictiveSearch =
    async query => {

      const clean =
        String(query || '').trim();

      const wrap =
        document.querySelector(
          '[data-synx-results]'
        );

      if (!clean) {
        if (wrap) {
          wrap.hidden = true;
          wrap.innerHTML = '';
        }

        return;
      }

      if (controller) {
        controller.abort();
      }

      controller =
        new AbortController();

      try {

        const endpoint =
          `${root}search/suggest.json` +
          `?q=${encodeURIComponent(clean)}` +
          `&resources[type]=product` +
          `&resources[limit]=6`;

        const response =
          await fetch(endpoint, {
            credentials: 'same-origin',
            signal: controller.signal,
            headers: {
              Accept: 'application/json'
            }
          });

        if (!response.ok) {
          throw new Error(
            `Search ${response.status}`
          );
        }

        const data =
          await response.json();

        const products =
          data?.resources?.results?.products ||
          [];

        renderProducts(products);

      } catch (error) {

        if (
          error.name !== 'AbortError'
        ) {
          console.warn(
            '[Synmac mobile search]',
            error
          );
        }
      }
    };


  /* ======================================================
     EVENTS
     ====================================================== */

  const bindUI = () => {

    const overlay =
      $('.synx-mobile-overlay');

    overlay?.addEventListener(
      'click',
      closeAll
    );


    $$('[data-synx-close]')
      .forEach(button => {
        button.addEventListener(
          'click',
          closeAll
        );
      });


    document.addEventListener(
      'keydown',
      event => {
        if (event.key === 'Escape') {
          closeAll();
        }
      }
    );


    /* Trending pill */
    document.addEventListener(
      'click',
      event => {

        const pill =
          event.target.closest(
            '[data-synx-term]'
          );

        if (!pill) return;

        const input =
          $('[data-synx-search-input]');

        if (!input) return;

        input.value =
          pill.getAttribute(
            'data-synx-term'
          ) || '';

        input.focus();

        predictiveSearch(
          input.value
        );
      }
    );


    /* Search typing */
    const input =
      $('[data-synx-search-input]');

    input?.addEventListener(
      'input',
      () => {

        window.clearTimeout(
          searchTimer
        );

        searchTimer =
          window.setTimeout(
            () => {
              predictiveSearch(
                input.value
              );
            },
            220
          );
      }
    );
  };


  /* ======================================================
     INTERCEPT MOBILE HEADER BUTTONS
     Capture phase prevents OLD drawer opening too
     ====================================================== */

  document.addEventListener(
    'click',
    event => {

      if (!MOBILE.matches) return;


      /* ---------- SEARCH ---------- */

      const searchTrigger =
        event.target.closest(
          [
            '.header__icon--search',
            'summary.header__icon--search',
            '[data-synp-search-open]'
          ].join(',')
        );

      if (searchTrigger) {

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  /* Force-close Shopify's old/native search modal on mobile */
  document
    .querySelectorAll('details-modal.header__search > details')
    .forEach(details => {
      details.removeAttribute('open');
    });

  const drawer =
    $('.synx-search-drawer');

  if (drawer) {
    openDrawer(drawer, searchTrigger);
  }

  return;
}


      /* ---------- ACCOUNT ---------- */

      const accountTrigger =
        event.target.closest(
          [
            '.header__icon--account',
            '[data-synp-account-open]',
            '.synp-mobile-account-trigger'
          ].join(',')
        );

      if (accountTrigger) {

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const drawer =
          $('.synx-account-drawer');

        if (drawer) {
          openDrawer(drawer, accountTrigger);
        }
      }

    },
    true
  );


  /* ======================================================
     RESET WHEN LEAVING MOBILE
     ====================================================== */

  MOBILE.addEventListener(
    'change',
    event => {

      if (!event.matches) {
        closeAll(false);
      }
    }
  );


  /* ======================================================
     INIT
     ====================================================== */

  const init = () => {
    buildUI();
  };


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

})();


/* =========================================================
   SYNMAC ALL PRODUCTS — DESKTOP LINK ONLY
   Mobile keeps Shopify native submenu behavior
   ========================================================= */

(() => {
  'use strict';

  if (window.__synmacAllProductsDesktopFix) return;
  window.__synmacAllProductsDesktopFix = true;

  const normalizeText = (value = '') =>
    String(value)
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  document.addEventListener(
    'click',
    (event) => {

      /* MOBILE:
         Don't interfere.
         Shopify's native drawer opens the submenu.
      */
      if (
        window.matchMedia('(max-width: 989px)').matches
      ) {
        return;
      }

      /* DESKTOP ONLY */
      const summary =
        event.target.closest('summary');

      if (!summary) return;

      const headerArea =
        summary.closest(
          '.header, .header-wrapper, header-menu'
        );

      if (!headerArea) return;

      if (
        normalizeText(summary.textContent) !==
        'all products'
      ) {
        return;
      }

      event.preventDefault();

      const root =
        window.Shopify?.routes?.root || '/';

      window.location.assign(
        `${root}collections/all`
      );

    },
    true
  );

})();
/* =========================================================
   SYNMAC MOBILE NAVIGATION PRO
   Isolated controller
   ========================================================= */

(() => {
  'use strict';

  if (window.__synmacMobileNavigationPro) return;
  window.__synmacMobileNavigationPro = true;

  const MOBILE =
    window.matchMedia('(max-width: 989px)');

  const getSystem = () =>
    document.querySelector('[data-synm-menu]');

  const getDrawer = () =>
    getSystem()?.querySelector('.synm-drawer');

  const panels = () =>
    [
      ...(
        getSystem()?.querySelectorAll(
          '[data-synm-panel]'
        ) || []
      )
    ];


  let history = ['main'];


  const activatePanel = name => {

    const system = getSystem();

    if (!system) return;

    const target =
      system.querySelector(
        `[data-synm-panel="${CSS.escape(name)}"]`
      );

    if (!target) return;


    panels().forEach(panel => {

      panel.classList.toggle(
        'is-active',
        panel === target
      );

    });

  };


  const resetPanels = () => {

    history = ['main'];

    activatePanel('main');

  };


  const openMenu = () => {

    if (!MOBILE.matches) return;

    const system = getSystem();
    const drawer = getDrawer();

    if (!system || !drawer) return;


    resetPanels();

    system.classList.add('is-open');
    system.classList.remove('synm-underline-run');

const underlineRows =
  system.querySelectorAll(
    '.synm-panel--main .synm-menu-row--underlined'
  );

underlineRows.forEach((row, index) => {
  row.style.setProperty(
    '--synm-underline-order',
    index
  );
});

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    system.classList.add(
      'synm-underline-run'
    );
  });
});

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement
      .classList.add('synm-lock');

    document.body
      .classList.add('synm-lock');

  };


  const closeMenu = () => {

    const system = getSystem();
    const drawer = getDrawer();

    if (!system || !drawer) return;


    system.classList.remove('is-open');
    system.classList.remove(
  'synm-underline-run'
);

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement
      .classList.remove('synm-lock');

    document.body
      .classList.remove('synm-lock');


    window.setTimeout(
      resetPanels,
      220
    );

  };


  const openPanel = name => {

    if (!name) return;

    history.push(name);

    activatePanel(name);

  };


  const backPanel = () => {

    if (history.length <= 1) {
      activatePanel('main');
      return;
    }

    history.pop();

    activatePanel(
      history[
        history.length - 1
      ]
    );

  };


  /*
   * Hamburger interception.
   *
   * Capture phase means Shopify's native drawer is
   * untouched in code and remains as automatic fallback
   * if this custom module is ever removed.
   */

  document.addEventListener(
    'click',
    event => {

      if (!MOBILE.matches) return;


      const hamburger =
        event.target.closest(
          [
            'summary.header__icon--menu',
            '.header__icon--menu'
          ].join(',')
        );


      if (hamburger) {

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openMenu();

        return;
      }


      const close =
        event.target.closest(
          '[data-synm-close]'
        );


      if (close) {

        event.preventDefault();

        closeMenu();

        return;
      }


      const opener =
        event.target.closest(
          '[data-synm-open]'
        );


      if (opener) {

        event.preventDefault();

        openPanel(
          opener.getAttribute(
            'data-synm-open'
          )
        );

        return;
      }


      const back =
        event.target.closest(
          '[data-synm-back]'
        );


      if (back) {

        event.preventDefault();

        backPanel();

      }

    },
    true
  );


  document.addEventListener(
    'keydown',
    event => {

      if (event.key === 'Escape') {
        closeMenu();
      }

    }
  );


  MOBILE.addEventListener(
    'change',
    event => {

      if (!event.matches) {
        closeMenu();
      }

    }
  );


  document.addEventListener(
    'shopify:section:load',
    () => {

      closeMenu();

    }
  );

})();